var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#2E2E2E",
    fillOpacity: 0.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3306 19.1165L20.8976 16.4155C21.0131 15.8651 21.3253 15.3699 21.7811 15.0142C22.2368 14.6584 22.808 14.4641 23.3973 14.4644H31.959C32.5483 14.4641 33.1194 14.6584 33.5752 15.0142C34.031 15.3699 34.3432 15.8651 34.4587 16.4155L35.0256 19.1165C35.1146 19.5397 35.3279 19.9302 35.6408 20.2425C35.9536 20.5548 36.3531 20.7762 36.7928 20.8808C37.8286 21.1276 38.7481 21.697 39.405 22.4986C40.062 23.3002 40.4188 24.2879 40.4188 25.3048V33.8786C40.4188 35.1659 39.8818 36.4004 38.9261 37.3106C37.9704 38.2209 36.6741 38.7322 35.3225 38.7322H20.0338C18.6821 38.7322 17.3859 38.2209 16.4302 37.3106C15.4744 36.4004 14.9375 35.1659 14.9375 33.8786V25.3048C14.9374 24.2879 15.2942 23.3002 15.9512 22.4986C16.6082 21.697 17.5277 21.1276 18.5635 20.8808C19.0032 20.7762 19.4027 20.5548 19.7155 20.2425C20.0283 19.9302 20.2416 19.5397 20.3306 19.1165V19.1165Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6783 33.8785C30.4929 33.8785 32.7745 31.7055 32.7745 29.025C32.7745 26.3444 30.4929 24.1714 27.6783 24.1714C24.8637 24.1714 22.582 26.3444 22.582 29.025C22.582 31.7055 24.8637 33.8785 27.6783 33.8785Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4043 19.3179H28.9524",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.30a5e12bc08a053081138cb765ba1ce6.svg";
export { ForwardRef as ReactComponent };